// extracted by mini-css-extract-plugin
export default {"Outer":"AppErrorList_Outer__h+71I","Image":"AppErrorList_Image__lE4TK"};